import { useMemo } from 'react';
import { InputTypes } from '../Input';

const INPUT_TYPES_MAP = new Map([['cvv', 'password']]);
const useInputType = (reactiveType: InputTypes): string => {
  return useMemo(
    () => INPUT_TYPES_MAP.get(reactiveType) || reactiveType,
    [reactiveType]
  );
};

export default useInputType;
